/**
 * Travel Cumulative Report Reducers
 */
import {
    CUMULATIVEREPORT_ACTION,
    ALL_CUMULATIVEREPORT,
 
 } from 'Actions/types';
 
 
 const INIT_STATE = {
     travelreportlist1:[],
     loading: false
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
         case CUMULATIVEREPORT_ACTION:
             return { ...state, loading: true };
 
         case ALL_CUMULATIVEREPORT:
             return { ...state, loading: false, travelreportlist1: action.payload };  

        
         default: return { ...state };
     }
 }